/**
 * The one count of a project's files: what the Files page lists at its top level and in its folders, the drawings
 * (listed under "Drawings") plus every stored file in every folder (not Trash). The sidebar, the first steps and the
 * Files page's own line all take their numbers from here and from `listedCounts`.
 */
export function projectFileCount(drawingCount: number, storedFileCount: number): number {
  return drawingCount + storedFileCount;
}
